import {
  Button,
  TextInputField,
  useModalState,
  Modal
} from '@sequencehq/core-components'
import { cloneElement, ReactElement } from 'react'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

interface Props {
  trigger: ReactElement
  onSubmit: (values: { name: string }) => Promise<void>
  initialName: string
}

const EditTaxCategoryNameModalUI = ({
  onSubmit,
  initialName,
  onClose
}: Omit<Props, 'trigger'> & { onClose: () => void }) => {
  const { fields, queries } = useForm({
    value: {
      name: initialName
    },
    fieldConfiguration: [
      {
        property: 'name',
        validation: [required]
      }
    ]
  })

  return (
    <>
      <Modal.Header showCloseButton withBorder onClose={onClose}>
        Edit tax category
      </Modal.Header>
      <Modal.Content minHeight="auto">
        <TextInputField
          label="Name"
          data-testid="editTaxCategoryName.name"
          value={fields.name.value}
          validationErrors={fields.name.validationErrors}
          onChange={e => fields.name.onChange(e.target.value)}
          placeholder="Tax category name"
        />
      </Modal.Content>

      <Modal.Footer withBorder>
        <Button
          onClick={onClose}
          style={{ marginLeft: 'auto' }}
          variant="secondary"
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          type="button"
          disabled={!queries.isValid}
          onClick={() => {
            onSubmit({ name: fields.name.value })
          }}
        >
          Edit tax category
        </Button>
      </Modal.Footer>
    </>
  )
}

const EditTaxCategoryNameModal = ({ trigger, ...props }: Props) => {
  const { isModalOpen, openModal, closeModal } = useModalState()

  const triggerWithOnClick = cloneElement(trigger, {
    onClick: (event: React.MouseEvent) => {
      if (trigger.props.onClick) {
        trigger.props.onClick(event)
      }

      openModal()
    }
  })

  return (
    <>
      {triggerWithOnClick}

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <EditTaxCategoryNameModalUI {...props} onClose={closeModal} />
      </Modal>
    </>
  )
}

export default EditTaxCategoryNameModal
